import React, { useEffect, useState } from 'react';
import {
  Container,
  Typography,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
  Alert,
  Box,
  CircularProgress,
} from '@mui/material';
import { fetchApi } from './fetchApi';

interface Bewegungseintrag {
  bewegung_id: number;
  zeitpunkt: string;
  typ: string;
  sku: string;
  bezeichnung: string;
  boxnummer: string;
  lagerort: string;
  menge: number;
  bemerkung: string | null;
}

export default function BewegungshistorieKompaktTabelle() {
  const [daten, setDaten] = useState<Bewegungseintrag[]>([]);
  const [fehler, setFehler] = useState<string | null>(null);
  const [laedt, setLaedt] = useState(true);

  useEffect(() => {
    fetchApi('/api/view/bewegungshistorie-kompakt')
      .then((res) => {
        if (!res.ok) throw new Error(String(res.status));
        return res.json();
      })
      .then((rows: Bewegungseintrag[]) => setDaten(Array.isArray(rows) ? rows : []))
      .catch((err: any) => {
        setFehler(
          err?.message === '401'
            ? 'Session abgelaufen. Bitte neu einloggen.'
            : 'Daten konnten nicht geladen werden.'
        );
        setDaten([]);
      })
      .finally(() => setLaedt(false));
  }, []);

  return (
    <Container maxWidth="xl">
      <Box mt={4} mb={2}>
        <Typography variant="h5">Bewegungshistorie</Typography>
      </Box>

      {fehler && <Alert severity="error">{fehler}</Alert>}

      {laedt ? (
        <Box display="flex" justifyContent="center" mt={4}>
          <CircularProgress />
        </Box>
      ) : (
        <Paper>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Zeitpunkt</TableCell>
                <TableCell>Typ</TableCell>
                <TableCell>SKU</TableCell>
                <TableCell>Bezeichnung</TableCell>
                <TableCell>Box</TableCell>
                <TableCell>Lagerort</TableCell>
                <TableCell align="right">Menge</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {daten.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={7} align="center" sx={{ opacity: 0.7 }}>
                    Keine Bewegungen vorhanden.
                  </TableCell>
                </TableRow>
              ) : (
                daten.map((e) => (
                  <TableRow key={e.bewegung_id}>
                    <TableCell sx={{ whiteSpace: 'nowrap' }}>
                      {new Date(e.zeitpunkt).toLocaleString('de-AT')}
                    </TableCell>
                    <TableCell sx={{ whiteSpace: 'nowrap' }}>{e.typ}</TableCell>
                    <TableCell>{e.sku}</TableCell>
                    <TableCell>{e.bezeichnung}</TableCell>
                    <TableCell>{e.boxnummer ?? '—'}</TableCell>
                    <TableCell>{e.lagerort ?? '—'}</TableCell>
                    <TableCell align="right">{e.menge}</TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </Paper>
      )}
    </Container>
  );
}
